/**
 * Main application page.
 */

'use strict';

var app              = require('mag-app'),
    keys             = require('stb-keys'),
    Footer           = require('mag-component-footer'),
    Panel            = require('mag-component-panel'),
    PanelSet         = require('mag-component-panel-set'),
    LayoutList       = require('mag-component-layout-list'),
    ModalMessage     = require('mag-component-modal'),
    RadioList        = require('mag-component-radio-list'),
    ScrollBar        = require('stb-component-scrollbar'),
    ScrollArea       = require('mag-component-scroll-area'),

    appExit          = require('../modules/app.exit'),
    webInput         = require('../modules/web.input'),
    previewImage     = require('../modules/preview.bookmark'),
    intents          = require('../modules/intents'),
    validateUrl      = require('../modules/validate.url'),
    div              = require('../modules/div'),

    page             = new (require('stb-component-page'))({$node: window.pageMain}),

    browser          = core.plugins.browser,
    messagesToEngine = browser.messages.toEngine,
    messagesToApp    = browser.messages.toApp,

    isBrowserInit    = false,
    bookmarks        = [],
    doc              = document,

    browseMessageReload,
    mainPanelList,
    headerAmount,
    navigationListData,
    settingsListData,
    progressBar,
    mainPanelSet,
    mainPanel,
    rightPanel,
    leftPanelMenu,
    mainPanelTitle,
    mainPanelListScroll,
    rightInfoPanelScroll,
    modalMessageScroll,
    mediaActionsModalList;


/**
 * Close already opened modal windows and set appropriate flags.
 */
function closeModalWindow () {
    Object.keys(page.modals).forEach(function ( modal ) {
        page.modals[modal].hide();
    });

    mainPanelSet.focus();
    app.flags.modalActive = false;
    page.footer.show();
}


/**
 * Construct comprehensive information about items in main central panel.
 *
 * @param {Object} data - data source
 */
function constructInfo ( data ) {
    var nodes = [
        data.title && div('title theme-subhead-color', data.title + ':'),
        div(null, data.text)
    ];

    page.textArea.$body.innerHTML = '';

    nodes.forEach(function ( node ) {
        if ( node ) {
            page.textArea.$body.appendChild(node);
        }
    });

    page.textArea.show();
    page.textArea.init();
}


/**
 * Construct bookmarks list with storage data.
 *
 * @param {string} [excludeUrl] - URL to exclude/remove from bookmarks
 *
 * @return {Object[]} bookmarks as ready to use constructed list
 */
function fillBookmarksList ( excludeUrl )  {
    var storedBookmarks = app.storage.bookmarks,
        index = storedBookmarks.length,
        data = [],
        favicon;

    if ( excludeUrl ) {
        while ( index-- ) {
            // is in bookmarks
            if ( storedBookmarks[index].url === excludeUrl ) {
                // remove from bookmarks
                storedBookmarks.splice(index, 1);
            } else {
                favicon = new Image();
                favicon.src = storedBookmarks[index].favicon;
                data.push({
                    items: [
                        {
                            value: favicon,
                            className: 'bookmarkListFavicon'
                        },
                        {
                            value: storedBookmarks[index].url,
                            className: 'bookmarkListUrl'
                        },
                        {
                            className: 'theme-icon theme-icon-favorite-active active'
                        }
                    ],
                    value: storedBookmarks[index]
                });
            }
        }
    } else {
        while ( index-- ) {
            favicon = new Image();
            favicon.src = storedBookmarks[index].favicon;
            data.push({
                items: [
                    {
                        value: favicon,
                        className: 'bookmarkListFavicon'
                    },
                    {
                        value: storedBookmarks[index].url,
                        className: 'bookmarkListUrl'
                    },
                    {
                        className: 'theme-icon theme-icon-favorite-active active'
                    }
                ],
                value: storedBookmarks[index]
            });
        }
    }

    return data;
}


/**
 * Set new data/new options to panel/list.
 *
 * @param {Object} data - array of station objects for parsing into LayoutList
 * @param {boolean} isDataRaw - flag that shows if given data is only data or whole config
 * @param {Object} [mixin] - some additional properties
 *
 * @return {boolean} result
 */
function reRender ( data, isDataRaw, mixin ) {
    var tmpData;

    if ( isDataRaw ) {
        tmpData = {
            scroll: data.length < 8 ? null : mainPanelListScroll,
            data: data,
            focusIndex: 0,
            cycle: true,
            size: 7
        };

        if ( mixin ) {
            Object.keys(mixin).forEach(function ( item ) {
                tmpData[item] = mixin[item];
            });
        }

        mainPanelList.init(tmpData);

        if ( data.length > 7 ) {
            if ( !mainPanel.scroller ) {
                mainPanel.scroller = true;
                mainPanelListScroll.init({
                    realSize: data.length
                });
                mainPanelListScroll.$node.style.display = '';
            }
        } else {
            mainPanel.scroller = false;
            mainPanelListScroll.$node.style.display = 'none';
        }

        headerAmount.innerHTML = data.length;
    } else {
        mainPanelList.init(data);
        headerAmount.innerHTML = data.data.length;
    }

    return true;
}


/**
 * Action for menu call for using in footer.
 *
 * @param {string} [url] - optional URL for loading
 */
function callMenu ( url ) {
    if ( app.flags.webWindowActive ) {
        app.flags.webWindowActive = false;
        mainPanelSet.show();
        app.addressBar.toggle();
        page.footer.init(page.footer.navigationViewConfig);
        app.flags.favoritesActive && reRender(fillBookmarksList(), true) && constructInfo({title: '', text: ''});
        app.flags.favoritesActive && page.footer.init(page.footer.bookmarksViewConfig);
    } else {
        app.flags.webWindowActive = true;
        mainPanelSet.hide();
        app.addressBar.toggle();
        page.footer.init(page.footer.browserViewConfig);
        browser.sendMessage(messagesToEngine.userSettings, app.storage);
        browser.sendMessage(messagesToEngine.showWebWindow, url);
    }
}


/**
 * Construct appropriate context menu for media resource.
 *
 * @param {Object} config - configuration parameters
 * @param {Object} config.data - media resource metadata
 * @param {boolean} config.playable - can media resource be played
 *
 * @return {Object} data for init list
 */
function constructListContent ( config ) {
    var data = [
        {
            items: [
                {
                    className: 'theme-icon theme-icon-download'
                },
                gettext('Download')
            ],
            click: function () {
                closeModalWindow();
                intents.openDownloads({
                    title: config.data.itemName,
                    uri:   config.data.itemLink
                }, callMenu);
            }
        }
    ];

    if ( config.playable ) {
        data.unshift({
            items: [
                {
                    className: 'theme-icon theme-icon-play'
                },
                gettext('Play')
            ],
            click: function () {
                closeModalWindow();
                intents.startPlayback({
                    mime:  config.data.itemMime,
                    title: config.data.itemName,
                    uri:   config.data.itemLink
                }, callMenu);
            }
        });
    }

    return {
        data:       data,
        size:       data.length,
        focusIndex: 0
    };
}


/**
 * Set or remove item from bookmarks collection.
 *
 * @param {Object} data - bookmark details
 */
function toggleFavorites ( data ) {
    var index;

    for ( bookmarks = app.storage.bookmarks, index = bookmarks.length; index--; ) {
        // is in bookmarks
        if ( bookmarks[index].url === data.url ) {
            // remove from bookmarks
            bookmarks.splice(index, 1);
            webInput.fillStar(app.addressBar.favorites, false);

            return;
        }
    }

    webInput.fillStar(app.addressBar.favorites, true);
    bookmarks.push({
        url: data.url,
        favicon: app.addressBar.favicon.src,
        title: data.title
    });
}


/**
 * Render menu on top of the page.
 */
// eslint-disable-next-line
function renderMenu () {
    var scale = app.storage.settings.scale,
        $scaleInfo, $fullScreenInfo, $virtualMouseInfo,
        navigationMenuInfoMap, settingsMenuInfoMap, links;

    mainPanelListScroll = new ScrollBar({
        viewSize: 7,
        className: 'mainPanelListScroll'
    });

    rightInfoPanelScroll = new ScrollBar({
        viewSize: 7,
        className: 'rightInfoPanelScroll'
    });

    modalMessageScroll = new ScrollBar({
        viewSize: 5,
        className: 'modalMessageScroll'
    });

    page.modals.setScale = new ModalMessage({
        parent: page,
        title: gettext('parameters'),
        events: {
            show: function () {
                this.focus();
                mainPanelSet.blur();
                page.footer.hide();
                app.flags.modalActive = true;
            },
            hide: closeModalWindow
        },
        children: [
            new RadioList({
                cycle: true,
                focusIndex: 0,
                size: 5,
                data: [
                    {
                        state: scale === 50,
                        title: '50%',
                        value: 50
                    },
                    {
                        state: scale === 75,
                        title: '75%',
                        value: 75
                    },
                    {
                        state: scale === 100,
                        title: '100%',
                        value: 100
                    },
                    {
                        state: scale === 150,
                        title: '150%',
                        value: 150
                    },
                    {
                        state: scale === 200,
                        title: '200%',
                        value: 200
                    },
                    {
                        state: scale === 300,
                        title: '300%',
                        value: 300
                    }
                ],
                events: {
                    'click:item': function ( event ) {
                        event = event.$item.data.value;
                        $scaleInfo.innerText = settingsListData.data[0].items[2].value = event + '%';
                        app.storage.settings.scale = event;
                        closeModalWindow();
                    }
                },
                scroll: modalMessageScroll
            })
        ]
    });

    page.modals.mediaAvailable = new ModalMessage({
        parent: page,
        title: gettext('Actions'),
        events: {
            show: function () {
                this.focus();
                mainPanelSet.blur();
                page.footer.hide();
                app.flags.modalActive = true;
            },
            hide: closeModalWindow
        },
        children: [
            mediaActionsModalList = new LayoutList({
                cycle: true,
                focusIndex: 0,
                size: 0,
                data: []
            })
        ]
    });

    navigationListData = {
        cycle: true,
        size: 6,
        focusIndex: 0,
        data: [
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-edit'
                    },
                    gettext('Edit the address bar')
                ],
                click: function () {
                    intents.openKeyboard({
                        title: app.addressBar.placeholder,
                        value: app.data.currentUrl
                    }, function ( keyboardEvent ) {
                        var data = keyboardEvent.value;

                        // sanitize URL
                        if ( !validateUrl(data) ) {
                            data = 'https://www.google.com/search?hl=' + core.environment.language + '&q=' + data;
                        }

                        if ( !app.flags.ignoreMessages ) {
                            callMenu();
                            browser.sendMessage(messagesToEngine.userTextInput, data);
                        }
                    });
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-rewind'
                    },
                    gettext('Back')
                ],
                click: function () {
                    browser.sendMessage(messagesToEngine.navigateBackward);
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-forward'
                    },
                    gettext('Forward')
                ],
                click: function () {
                    browser.sendMessage(messagesToEngine.navigateForward);
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-stop'
                    },
                    gettext('Stop')
                ],
                click: function () {
                    browser.sendMessage(messagesToEngine.stopLoad);
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-refresh'
                    },
                    gettext('Reload')
                ],
                click: function () {
                    browser.sendMessage(messagesToEngine.reload);
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-rc-f3'
                    },
                    gettext('Favorites')
                ],
                click: function () {
                    toggleFavorites({url: app.data.currentUrl, title: app.data.currentUrlTitle});
                }
            }
        ],
        events: {
            'focus:item': function () {
                constructInfo(navigationMenuInfoMap[this.$focusItem.index]);
            }
        }
    };

    settingsListData = {
        cycle: true,
        size: 3,
        focusIndex: 0,
        data: [
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-scale'
                    },
                    {
                        value: gettext('Scale')
                    },
                    $scaleInfo = div('settingState theme-text-disabled', app.storage.settings.scale + '%')
                ],
                click: function () {
                    page.modals.setScale.show();
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-aspect'
                    },
                    {
                        value: gettext('Full screen'),
                        className: 'settingTitle'
                    },
                    $fullScreenInfo = div('settingState theme-text-disabled', app.storage.settings.isFullScreen ? gettext('On') : gettext('Off'))
                ],
                click: function () {
                    var currentState = app.storage.settings.isFullScreen;

                    app.storage.settings.isFullScreen = !currentState;
                    $fullScreenInfo.innerText = settingsListData.data[1].items[2].value = currentState ? gettext('Off') : gettext('On');
                }
            },
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-virtual-mouse'
                    },
                    {
                        value: gettext('Virtual mouse'),
                        className: 'settingTitle'
                    },
                    $virtualMouseInfo = div('settingState theme-text-disabled', app.storage.settings.isVirtualMouse ? gettext('On') : gettext('Off'))
                ],
                click: function () {
                    var currentState = app.storage.settings.isVirtualMouse;

                    app.storage.settings.isVirtualMouse = !currentState;
                    $virtualMouseInfo.innerText = settingsListData.data[1].items[2].value = currentState ? gettext('Off') : gettext('On');
                }
            }
        ],
        events: {
            'focus:item': function () {
                constructInfo(settingsMenuInfoMap[this.$focusItem.index]);
            },
            'click:item': function ( event ) {
                this.handlers[event.$item.index](event.$item);
            }
        }
    };

    navigationMenuInfoMap = [
        // eslint-disable-next-line
        {title: gettext('Button “Edit the address bar”'), text: gettext('Click on the "Edit the address bar" button to edit content in the address bar')},
        {title: gettext('Button “Back”'), text: gettext('Click on the “Back” button to go to the previous page')},
        {title: gettext('Button “Forward”'), text: gettext('Click on the “Forward” button to go to the next page')},
        {title: gettext('Button “Stop”'), text: gettext('Click on the "Stop" button to stop the page loading')},
        {title: gettext('Button “Reload”'), text: gettext('Click on the “Reload” button to reload the page')},
        {title: gettext('Button “Favorites”'), text: gettext('Click on the “Favorites” button to go to bookmarks')}
    ];

    settingsMenuInfoMap = [
        {title: '', text: gettext('Scale is the ratio of the visual size of the object image to its actual size.')},
        {title: '', text: gettext('Full-screen mode expands the browser window.')},
        {title: '', text: gettext('Virtual mouse is the option to emulate mouse behavior with keyboard.')}
    ];

    page.textArea = new ScrollArea({propagate: true, scroll: rightInfoPanelScroll, step: 1});

    page.add(
        mainPanelSet = new PanelSet({
            visible: !app.flags.webWindowActive,
            panels: [
                new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('menu'),
                            className: 'name'
                        }
                    ],
                    children: [
                        leftPanelMenu = new LayoutList({
                            cycle: true,
                            size: 5,
                            focusIndex: 0,
                            data: [
                                {
                                    name: 'navigation',
                                    items: [
                                        {
                                            name: '$icon',
                                            className: 'theme-icon theme-icon-navigate'
                                        },
                                        gettext('Navigation')
                                    ],
                                    click: function () {
                                        app.flags.favoritesActive = false;

                                        links.favorites.links.$icon.className = 'theme-icon theme-icon-favorite';
                                        links.settings.links.$icon.classList.remove('active');
                                        links.navigation.links.$icon.classList.add('active');

                                        reRender(navigationListData, false);
                                        mainPanel.$node.classList.remove('settings');
                                        mainPanelTitle.innerText = gettext('Navigation');
                                        page.footer.init(page.footer.navigationViewConfig);
                                    }
                                },
                                {
                                    name: 'favorites',
                                    items: [
                                        {
                                            name: '$icon',
                                            className: 'theme-icon theme-icon-favorite'
                                        },
                                        gettext('Favorites')
                                    ],
                                    click: function () {
                                        mainPanel.$node.classList.remove('settings');
                                        mainPanelTitle.innerText = gettext('Favorites');

                                        links.navigation.links.$icon.classList.remove('active');
                                        links.settings.links.$icon.classList.remove('active');
                                        links.favorites.links.$icon.className = 'theme-icon theme-icon-favorite-active active';

                                        page.footer.init(page.footer.navigationViewConfig);
                                        reRender(fillBookmarksList(), app.flags.favoritesActive = true, {
                                            events: {
                                                'focus:item': function () {
                                                    clearTimeout(this.timerId);
                                                    this.timerId = setTimeout(function () {
                                                        if ( mainPanelList.$focusItem ) {
                                                            previewImage(
                                                                page,
                                                                mainPanelList.$focusItem.data.value.url,
                                                                mainPanelList.$focusItem.data.value
                                                            );
                                                        }
                                                    }, core.environment.onFocusDebounceTimeout);
                                                },
                                                'click:item': function () {
                                                    callMenu(mainPanelList.$focusItem.data.value.url);
                                                }
                                            }
                                        });
                                        constructInfo({title: '', text: ''});
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-download'
                                        },
                                        gettext('Downloads')
                                    ],
                                    click: function () {
                                        intents.openDownloads({}, callMenu);
                                    }
                                },
                                {
                                    name: 'settings',
                                    items: [
                                        {
                                            name: '$icon',
                                            className: 'theme-icon theme-icon-settings'
                                        },
                                        gettext('Settings')
                                    ],
                                    click: function () {
                                        app.flags.favoritesActive = false;

                                        links.favorites.links.$icon.className = 'theme-icon theme-icon-favorite';
                                        links.navigation.links.$icon.classList.remove('active');
                                        links.settings.links.$icon.classList.add('active');

                                        reRender(settingsListData, false);
                                        mainPanelTitle.innerText = gettext('Settings');
                                        page.footer.init(page.footer.settingsViewConfig);
                                        mainPanel.$node.classList.add('settings');
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-exit'
                                        },
                                        gettext('Exit')
                                    ],
                                    click: function () {
                                        mainPanelSet.blur();
                                        appExit.goExit();
                                    }
                                }
                            ]
                        })
                    ],
                    events: {
                        focus: function ( event ) {
                            Panel.prototype.defaultEvents.focus.call(this, event);
                            app.flags.favoritesActive && page.footer.init(page.footer.navigationViewConfig);
                        }
                    }
                }),
                mainPanel = new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('files'),
                            className: 'name'
                        },
                        div('amountContainer', headerAmount = div('amount', 6))
                    ],
                    main: true,
                    children: [mainPanelList = new LayoutList(navigationListData)],
                    events: {
                        focus: function ( event ) {
                            Panel.prototype.defaultEvents.focus.call(this, event);
                            app.flags.favoritesActive && page.footer.init(page.footer.bookmarksViewConfig);
                        }
                    }
                }),
                rightPanel = new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('info'),
                            className: 'name'
                        }
                    ],
                    children: []
                })
            ]
        })
    );

    page.textArea.addListener('click', function () {
        app.flags.favoritesActive && mainPanelList.emit('click:item');
    });

    mainPanel.$body.appendChild(mainPanelListScroll.$node);
    page.modals.setScale.$body.appendChild(modalMessageScroll.$node);
    rightPanel.add(page.textArea, rightInfoPanelScroll);

    if ( bookmarks.length <= 7 ) {
        mainPanelListScroll.$node.style.display = 'none';
    }

    navigationListData.events['click:item'] = function ( event ) {
        this.handlers[event.$item.index](event.$item);
    };

    links = leftPanelMenu.links;
    app.mainPanelSet = mainPanelSet;
    mainPanelTitle = mainPanel.title.$body.children[0];
    mainPanelTitle.innerText = leftPanelMenu.$focusItem.data.items[1].value;
    mainPanel.focus();
}


/**
 * Main page render. Do basic initialization stuff here.
 */
function renderPage () {
    progressBar = webInput.setProgressBar({className: 'progressBar'});
    page.modals = {};
    page.footer = new Footer({parent: page});

    page.footer.browserViewConfig = {
        left: {
            code: keys.menu,
            action: function () {
                browser.sendMessage(messagesToEngine.hideWebWindow);
            }
        },
        middle: [
            {
                code: keys.f1,
                title: gettext('Reload'),
                action: function () {
                    browser.sendMessage(messagesToEngine.reload);
                }
            },
            {
                code: keys.keyboard,
                title: gettext('Virtual keyboard'),
                action: function () {
                    browser.sendMessage(messagesToEngine.openVirtualKeyboard);
                }
            },
            {
                code: keys.f3,
                title: gettext('Favorites'),
                action: function () {
                    toggleFavorites({url: app.data.currentUrl, title: app.data.currentUrlTitle});
                }
            },
            {
                code: keys.f4,
                title: gettext('Address bar'),
                action: function () {
                    browser.sendMessage(messagesToEngine.search);
                }
            }
        ],
        right: {
            code: keys.frame,
            action: function () {
                browser.sendMessage(messagesToEngine.setFullScreen);
            }
        }
    };

    page.footer.navigationViewConfig = {
        left: {
            code: keys.menu,
            action: callMenu
        }
    };

    page.footer.bookmarksViewConfig = {
        left: {
            code: keys.menu,
            action: callMenu
        },
        middle: [
            {
                code: keys.f3,
                title: gettext('Favorites'),
                action: function () {
                    var activeItem = mainPanelList.$focusItem;

                    if ( app.flags.favoritesActive && activeItem ) {
                        // re-render list with new bookmarks data
                        reRender(fillBookmarksList(activeItem.data.value.url), true);
                        app.storage.bookmarks.length || (page.textArea.$body.innerHTML = '');
                    }
                }
            }
        ]
    };

    page.footer.settingsViewConfig = {
        left: {
            code: keys.menu,
            action: callMenu
        }
    };

    page.add(progressBar);
    page.footer.init(page.footer.browserViewConfig);
    page.footer.show();

    app.addressBar = {
        faviconBlock: doc.getElementById('addressBarFavicon'),
        loader: doc.getElementById('loader'),
        favicon: doc.getElementById('favicon'),
        placeholder: 'Enter url address or text to search...',
        url: doc.getElementById('addressBar'),
        progress: progressBar,
        favorites: doc.getElementById('addressBarFavorites'),
        toggle: function () {
            this.faviconBlock.classList.toggle('hidden');
            this.url.classList.toggle('hidden');
            this.favorites.classList.toggle('hidden');
            this.progress.$node.classList.toggle('hidden');
        }
    };

    renderMenu();
}


page.once('show', renderPage);

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            (app.flags.modalActive ? closeModalWindow : callMenu)();
            break;
        case keys.ok:
            app.flags.favoritesActive && rightPanel.$node.classList.contains('active') && mainPanelList.emit('click:item');
            break;
    }
});


/**
 * Callback function for handling messages from browser engine.
 * There are many gSTB API usages in handling logic, so main work happens in corresponding plugin.
 * So here we can add some additional non-primary logic.
 *
 * @param {Object} event - event object
 */
browser.onMessageReceive = function ( event ) {
    var itemPlayable = false,
        index, progressLevel, mimeType;

    switch ( event.message ) {
        case messagesToApp.back:
            if ( app.intent ) {
                app.intent.close();
            } else {
                appExit.goBack();
            }

            break;
        case messagesToApp.home:
            appExit.goHome();
            break;
        case messagesToApp.search:
            intents.openKeyboard({
                title: app.addressBar.placeholder,
                value: app.data.currentUrl
            },
            function ( keyboardEvent ) {
                var data = keyboardEvent.value;

                // sanitize URL
                if ( !validateUrl(data) ) {
                    data = 'https://www.google.com/search?hl=' + core.environment.language + '&q=' + data;
                }

                if ( !app.flags.ignoreMessages ) {
                    browser.sendMessage(messagesToEngine.userSettings, app.storage);
                    browser.sendMessage(messagesToEngine.userTextInput, data);
                }
            });
            break;
        case messagesToApp.mediaAvailable:
            mimeType = event.data.itemMime.split('/')[0];
            itemPlayable = ['audio', 'video'].indexOf(mimeType) !== -1;
            event.data.itemName = decodeURIComponent(event.data.itemName);

            if ( itemPlayable ) {
                event.data.itemMime = 'content/' + mimeType;
            }

            mediaActionsModalList.init(constructListContent({
                data:     event.data,
                playable: itemPlayable
            }));

            page.modals.mediaAvailable.show();
            break;
        case messagesToApp.reload:
            browseMessageReload(browseMessageReload.initUrl, browseMessageReload.currentUrl = event.data);
            break;
        case messagesToApp.openMenu:
            callMenu();
            break;
        case messagesToApp.changeUrl:
            // full-fill user history of visited pages
            app.addressBar.url.innerText = app.data.currentUrl = event.data.url;
            app.data.currentUrlTitle = event.data.title;
            // reset visual favorites state
            webInput.fillStar(app.addressBar.favorites, false);

            for ( index = app.storage.bookmarks.length; index--; ) {
                if ( app.storage.bookmarks[index].url === app.data.currentUrl ) {
                    webInput.fillStar(app.addressBar.favorites, true);
                    break;
                }
            }

            break;
        case messagesToApp.setLoadProgress:
            progressLevel = Number(event.data);
            app.addressBar.progress.set(progressLevel === 100 ? 0 : progressLevel);
            break;
        case messagesToApp.setFavicon:
            app.addressBar.favicon.onload = function () {
                app.addressBar.loader.classList.add('hidden');
                app.addressBar.favicon.classList.remove('hidden');
            };
            app.addressBar.favicon.onerror = function () {
                app.addressBar.favicon.classList.add('noFavicon');
                app.addressBar.loader.classList.add('hidden');
                app.addressBar.favicon.classList.remove('hidden');
            };
            app.addressBar.favicon.src = webInput.setFavicon(app.data.currentUrl);
            break;
        case messagesToApp.unsetFavicon:
            app.addressBar.favicon.classList.add('hidden');
            app.addressBar.favicon.classList.remove('noFavicon');
            app.addressBar.loader.classList.remove('hidden');
            break;
        case messagesToApp.favoritesState:
            toggleFavorites(event.data);
            break;
        case messagesToApp.notification:
            core.notify({
                title: event.data,
                icon: 'info',
                type: 'error'
            });
            break;
        case messagesToApp.openTaskManager:
            callMenu();
            intents.openTaskManager(callMenu);
            break;
        case messagesToApp.openSettings:
            intents.openSystemSettings(callMenu);
            break;
        case messagesToApp.ready:
            browser.sendMessage(messagesToEngine.userSettings, app.storage);
            break;
    }
};

core.addListener('intent', function ( intent, callback ) {
    var context = {};

    if ( intent.action === 'browse' ) {
        // error
        if ( !intent.data || !intent.data.uri ) {
            callback(true, null);

            return;
        }

        if ( intent.events && intent.events.reload ) {
            browseMessageReload = intent.events.reload[0];
            browseMessageReload.initUrl = intent.data.uri;
        }

        if ( isBrowserInit ) {
            browser.sendMessage(messagesToEngine.intentUrl, intent.data.uri);
        } else {
            console.log('Browser invoked by intent.....');
            isBrowserInit = true;
            browser.init({data: ['page=' + intent.data.uri], purpose: 'parameter'});
        }

        app.intent = intent;

        Object.defineProperty(context, 'uri', {
            get: function () {
                return browseMessageReload.currentUrl || browseMessageReload.initUrl;
            }
        });

        callback(false, context);
    }
});

if ( !isBrowserInit ) {
    browser[browser.standalone ? 'initStandalone' : 'initRegular']();
}

core.addListeners({
    show: function () {
        app.flags.ignoreMessages = false;

        if ( app.flags.webWindowActive ) {
            browser.sendMessage(messagesToEngine.showWebWindow);
        }
    },
    hide: browser.showPortalWindow
});

module.exports = page;
